import { AxiosResponse } from 'axios';
import Repository from './Repository';
import { DeliveryPointData } from '@/types/delivery-point';

export type DeliveryPointsResponse = DeliveryPointData[];

export type DeliveryPointsError = {
  error: {
    message: string;
  };
};

const resource = 'validate';
const requestConfig = {
  headers: {
    'Content-Type': 'multipart/form-data',
  },
};

export default class DeliveryFileRepository {
  public static checkDeliveryFile = (
    filePath: File,
    withConfection: boolean,
  ): Promise<AxiosResponse<DeliveryPointsResponse[] | DeliveryPointsError>> => {
    const formData = new FormData();

    formData.append('delivery_file', filePath);
    formData.append('confection', String(withConfection));
    return Repository.post(`${resource}/delivery-file`, formData, requestConfig);
  };
}
